// @lib-export
class AvatarData {
}
class AvatarDataImage extends AvatarData {
    url;
}
class AvatarDataIcon extends AvatarData {
    borderColor;
    icon;
    iconColor;
    iconFontWeight;
    iconSize;
}
class AvatarDataInitials extends AvatarData {
    initials;
    color;
    //white by default
    fontColor;
}

export { AvatarData, AvatarDataIcon, AvatarDataImage, AvatarDataInitials };
//# sourceMappingURL=avatar-data.js.map
